import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DirectorySearch } from '../components/DirectorySearch/DirectorySearch';
import { theme } from 'antd';
import { useVenues } from '../api/queries';
import { VenueListing } from '../components/DirectoryListings/VenueListing/VenueListing';
import { useHeader } from '../components/Layout/MainLayout';

function Venues() {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { data: venues, isLoading, error } = useVenues();
  const { searchQuery } = useHeader();
  const q = searchQuery.toLowerCase();

  const handleVenueClick = (venueId: string) => {
    navigate(`/venues/${venueId}`);
  };

  return (
    <div className="directory-page">
      <div className="directory-page__tabs">
        <DirectorySearch activeTab="venues" />
      </div>
      <div className="body-temp directory-page__list">
        {isLoading && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            Loading venues...
          </div>
        )}

        {error && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorError }}>
            Error loading venues: {error.message}
          </div>
        )}

        {venues && venues.length > 0 && (() => {
          const filteredVenues = q
            ? venues.filter(venue =>
                venue.name.toLowerCase().includes(q) ||
                (venue.address || '').toLowerCase().includes(q)
              )
            : venues;
          return filteredVenues.length > 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}>
              {filteredVenues.map((venue) => (
                <VenueListing
                  key={venue.id}
                  name={venue.name}
                  location={venue.address}
                  imageUrl={venue.photo_url}
                  onClick={() => handleVenueClick(venue.id)}
                />
              ))}
            </div>
          ) : (
            <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
              No venues found.
            </div>
          );
        })()}

        {venues && venues.length === 0 && !q && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            No venues found.
          </div>
        )}
      </div>
    </div>
  );
}

export default Venues;
